import { Component } from '@angular/core';
import { AiChatFloatingComponent } from '../ai-chat-floating/ai-chat-floating.component';

@Component({
  selector: 'app-ai-chat-integrated',
  templateUrl: './ai-chat-integrated.component.html',
  styleUrls: ['./ai-chat-integrated.component.scss']
})
export class AiChatIntegratedComponent extends AiChatFloatingComponent {
  protected override useFloatingVisibility = false;
}